import _ from 'lodash';

import { featureRoute } from '../helpers';
import { DaySaveStages } from '../../constants/AppConstants';
import DaySaveActions from '../../actions/DaySaveActions';
import urls from '../../urls';

export default featureRoute('enableDaySave', DaySaveStages.RESULTS, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/daySave/Results').default);
        }, 'daysave-results');
    },

    onEnter (nextState, replace, callback) {
        const { params, location } = nextState;
        DaySaveActions.loadFromParams(params, location.query).then((search) => {
            if (!search.isValid()) {
                replace(urls.location(DaySaveStages.SEARCH));
            }
           _.defer(callback);
        });
    }
});
